import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate' // 👈 You already have this import, which is great.

import App from './App.vue'
import router from './router'
import "tiny-slider/dist/tiny-slider.css";
//import { useProductStore } from './stores/useProductStore';

import 'vue3-toastify/dist/index.css'
import Vue3Toastify from 'vue3-toastify'


const app = createApp(App)

const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)

app.use(router)
app.use(pinia)

//const productStore = useProductStore();
//productStore.initializeProducts();

app.use(Vue3Toastify, {
  autoClose: 3000,
  position: "top-right"
})

app.mount('#app')
